import { TimeseriesUnit } from '../../core/types/timeseries.js';
import { TimeseriesPerVariant } from '../types/timeseries.js';

const MAX_ALLOWED_UNITS = 2;

const getMainUnits = (unitSet: TimeseriesUnit[]) =>
  unitSet.slice(0, MAX_ALLOWED_UNITS);

export function getSanitizedValueNoMaximumUnits(
  dataPerVariant: TimeseriesPerVariant,
  units: TimeseriesUnit[],
) {
  const mainUnits = getMainUnits(units);

  return {
    line: dataPerVariant.line?.filter(({ unit }) => mainUnits.includes(unit)),
    area: dataPerVariant.area?.filter(({ unit }) => mainUnits.includes(unit)),
    bar: dataPerVariant.bar?.filter(({ unit }) => mainUnits.includes(unit)),
    band: dataPerVariant.band?.filter(({ unit }) => mainUnits.includes(unit)),
    shapePriority: dataPerVariant.shapePriority,
  };
}
